import PageHeader from '../layout/PageHeader'
import BuildIcon from '@mui/icons-material/Build'
import PageContainer from '../layout/PageContainer'
import DataTable from '../dataTable/DataTable'
import StoreKeyProvider from '../../providers/StoreKeyProvider'
import WithFilters from '../../hocs/WithFilters'
import { Card, CardContent, Button, CardHeader } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { useDispatch, useSelector } from 'react-redux'
import { openPopup } from '../../../store/popupsSlice'
import DataInputs from '../dataTable/DataInputs'

const Home = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user.user)
  return (
    <>
      <PageHeader
        icon={<BuildIcon fontSize="large" />}
        title="Administratorzy"
        subtitle="Tutaj znajdziesz listę administratorów zarejestrowanych w systemie"
      />
      <PageContainer>
        <StoreKeyProvider storeKey="AdministratorsKey">
          <WithFilters
            config={{
              page: 1,
              paginate: 10,
              orderType: 'asc',
              order: 'firstname',
              inputs: {
                firstname: {
                  values: '',
                  relation: 'LIKE',
                },
                lastname: {
                  value: '',
                  relation: 'LIKE',
                },
                phone_number: {
                  value: null,
                  relation: 'LIKE',
                },
                email: {
                  value: null,
                  relation: 'LIKE',
                },
                pwz: {
                  value: '',
                  relation: 'LIKE',
                },
              },
            }}
            endpoint="/admins"
          >
            <Card elevation={2} square>
              <CardHeader
                title="Lista administratorów"
                action={
                  user.role_id == 1 &&
                  user.permissions.includes('store User') && (
                    <Button
                      startIcon={<AddIcon />}
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        dispatch(
                          openPopup({
                            component: 'AdministratorsFactory',
                            title: 'Dodaj administratora',
                            level: 1,
                            maxWidth: 'sm',
                            key: 'admin-factory-popup',
                          })
                        )
                      }
                    >
                      Dodaj
                    </Button>
                  )
                }
              />
              <CardContent>
                <DataInputs
                  inputs={[
                    {
                      id: 'firstname',
                      label: 'Imię',
                      placeholder: '',
                      type: 'text',
                    },
                    {
                      id: 'lastname',
                      label: 'Nazwisko',
                      placeholder: '',
                      type: 'text',
                    },
                    {
                      id: 'phone_number',
                      label: 'Nr. Tel.',
                      placeholder: '',
                      type: 'tel',
                    },
                    {
                      id: 'email',
                      label: 'E-mail',
                      placeholder: '',
                      type: 'text',
                    },
                    {
                      id: 'pwz',
                      label: 'Nr. PWZ',
                      placeholder: '',
                      type: 'text',
                    },
                  ]}
                />
                <DataTable
                  breakpoint={1200}
                  actions="AdminsTableActions"
                  labels={['Imię', 'Nazwisko', 'Nr. Tel.', 'E-mail', 'Nr. PWZ']}
                  keys={[
                    'firstname',
                    'lastname',
                    'phone_number',
                    'email',
                    'pwz',
                  ]}
                />
              </CardContent>
            </Card>
          </WithFilters>
        </StoreKeyProvider>
      </PageContainer>
    </>
  )
}

export default Home
